import drugInput from './saveInputs/drugInput';

export default (drug) => `
    saveDrug (drug: {
        ${drugInput(drug)}
    }) {
        id
    }
`;
